import React from 'react';
import { ArrowUpRight, Shield } from 'lucide-react';
import { motion } from 'framer-motion';

const GuaranteeSection = ({ onOpenContactForm }) => (
  <section data-testid="guarantee-section" className="py-24 md:py-32 bg-stone-900 overflow-hidden">
    <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
      <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
        <Shield className="w-16 h-16 text-emerald-500 mx-auto mb-8" strokeWidth={1} />
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-stone-50 leading-[1.1] mb-6">Your Brand.<br/>Our <span className="italic text-orange-500">Guarantee.</span></h2>
        <p className="text-lg text-stone-400 leading-relaxed mb-10 max-w-xl mx-auto">Licensed attorneys file every application. A dedicated case manager owns your case. Every step is transparent. We built this service because your brand deserves nothing less.</p>
        <button onClick={onOpenContactForm}
          className="group inline-flex items-center gap-2 px-10 py-5 bg-orange-600 text-white font-bold text-base tracking-wide border-2 border-orange-600 hover:-translate-y-1 hover:translate-x-1 hover:shadow-[-8px_8px_0px_#065F46] transition-all duration-200">
          Start Protecting Your Brand <ArrowUpRight className="w-5 h-5 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform duration-200" />
        </button>
        <p className="text-sm text-stone-500 mt-4">Starting at $45 + government filing fees</p>
      </motion.div>
    </div>
  </section>
);
export default GuaranteeSection;
